
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[scanCode]",
      function () {
        return require("private-next-pages/[scanCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[scanCode]"])
      });
    }
  